package se.mittpass.shared.repository

import io.ktor.client.*
import io.ktor.client.call.body
import io.ktor.client.request.*
import se.mittpass.shared.api.*

class ProjectRepository(private val httpClient: HttpClient) {
    suspend fun getProjects(workplaceId: Long): Result<List<ProjectDto>> = runCatching {
        httpClient.get("workplaces/$workplaceId/projects").body()
    }
    suspend fun createProject(workplaceId: Long, req: CreateProjectRequest): Result<Unit> = runCatching {
        httpClient.post("workplaces/$workplaceId/projects") { setBody(req) }
    }
    suspend fun toggleProject(projectId: Long): Result<Unit> = runCatching {
        httpClient.put("projects/$projectId/toggle")
    }
    suspend fun getTimeEntries(workplaceId: Long, projectId: Long? = null): Result<List<ProjectTimeEntryDto>> = runCatching {
        httpClient.get("workplaces/$workplaceId/time-entries") {
            projectId?.let { parameter("projectId", it) }
        }.body()
    }
    suspend fun createTimeEntry(workplaceId: Long, req: CreateTimeEntryRequest): Result<Unit> = runCatching {
        httpClient.post("workplaces/$workplaceId/time-entries") { setBody(req) }
    }
}
